<template>
  <div class="attachments">
    <div class="title">
      附件说明
    </div>
    <div class="btn-group">
      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadaction"
        style="display: inline-block;margin: 0 10px"
      >
        <el-button type="primary" class="upload-btn" disabled>
          上传合同
        </el-button>
      </el-upload>
      <el-button type="default" class="mr8 download-btn" disabled @click="downFiles">
        下载合同
      </el-button>
    </div>
    <div class="table-box">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          align="left"
          width="55"
        />
        <el-table-column
          prop="fileName"
          label="文件名称"
          align="left"
        />
        <el-table-column
          prop="createdBy"
          label="上传人"
          align="left"
        />
        <el-table-column
          prop="createdTime"
          label="上传时间"
          show-overflow-tooltip
          align="left"
        />
        <el-table-column
          prop="updatedTime"
          label="最后更新时间"
          show-overflow-tooltip
          align="left"
        />
        <el-table-column label="操作" align="left" fixed="right">
          <template slot-scope="scope">
            <el-popconfirm
              disabled
              title="确定删除该文件吗？"
              @confirm="handleDelete(scope.$index, scope.row)"
            >
              <el-link
                slot="reference"
                :underline="false"
                type="primary"
                class="fz-12"
                disabled
              >
                删除
              </el-link>
            </el-popconfirm>
            <el-link
              :underline="false"
              type="primary"
              class="ml-16 fz-12"
              disabled
              @click="downOneFile(scope.row)"
            >
              下载
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      multipleSelection: []
    };
  },
  components: {},
  methods: {
    handleDelete (index, row) {
    },
    handleSelectionChange (val) {
    },
    downFiles () {

    },
    downOneFile (row) {
    },
    checkSpecialCharacters (str) {

    },
    // 上传文件
    uploadaction (upload) {
    }
  }
};
</script>
<style lang="scss" scoped>
.attachments{
  margin-top: 12px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  .title{
    color: #383838;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .btn-group{
    margin-bottom: 12px;
    ::v-deep .el-button{
      font-size: 14px;
      border-radius: 4px;
    }
  }
}
.mr8{
  margin-right: 8px;
}
.ml-16{
  margin-left: 16px;
}
.fz-12{
  font-size: 12px;
}
</style>
